import { render, staticRenderFns } from "./ReleaseNote.vue?vue&type=template&id=77f32b82&"
import script from "./ReleaseNote.vue?vue&type=script&lang=js&"
export * from "./ReleaseNote.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNote.vue?vue&type=style&index=0&id=77f32b82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports